          <ng-container *ngIf="categoryId === 2 || categoryId === 5 || categoryId === 8">
               <ng-container *ngIf="categoryId !== 5">
                  <div
                    style="position: relative; cursor: pointer; overflow: hidden;"
                    [style.width]="categoryId === 5 ? '130px' : '200px'"
                    [style.height]="categoryId === 8 ? '110px' : (categoryId === 5 ? '50px' : '90px') "
                    (click)="openModal()">
                    <img
                        [src]="imageUrl"
                        [ngStyle]="{'width': categoryId === 5 ? '100px' : '100%',
                                    'height': categoryId === 5 ? '50px' : '100%'}"
                        style=" object-fit: contain; object-position: center;"
                        alt="Imagen del producto">
                </div>
               </ng-container>





              <ng-container *ngIf="categoryId === 5">

                <div class="d-flex flex-column justify-content-between align-items-center" style="height: 100%;padding-top: 3.2em;">
                  <div>

                    <div
                      style="position: relative; cursor: pointer;text-align: center "
                      [style.width]="categoryId === 5 ? '130px' : '200px'"
                      [style.height]="categoryId === 8 ? '110px' : (categoryId === 5 ? '50px' : '90px') "
                      (click)="openModal()">
                      <img
                          [src]="imageUrl"
                          [ngStyle]="{'width': categoryId === 5 ? '100px' : '100%',
                                      'height': categoryId === 5 ? '50px' : '100%'}"
                          style=" object-fit: contain; object-position: center;"
                          alt="Imagen del producto">
                    </div>

                    <div style="height: 1px; background:#eaeaea; width: 80%; margin: 0 auto;"></div>

                    <div
                        style="width: 130px;height: 55px; position: relative;text-align: center">
                        <ng-container *ngIf="logoAlliance === ''">
                          <div style="width: 85px;height: 55px;min-height: 30px"></div>
                        </ng-container>
                        <ng-container *ngIf="logoAlliance !== ''">
                             <img
                            [src]="logoAlliance"
                            style="width: 85px;height: 55px; object-fit: contain; object-position: center;"
                            alt="Imagen del producto">
                        </ng-container>

                    </div>

                    <div class="d-flex flex-column align-items-center">

                      <div class="d-flex align-items-center" style="gap: .5em;margin-bottom:10px">
                        <img src="../../../../../../assets/icons/search-result/aereo/exclusiveSeat.svg"
                                                tooltip="Asiento"
                 placement="bottom" style="width: 24px;" alt="">
                        <img src="../../../../../../assets/icons/search-result/aereo/carryOn.svg"
                                                tooltip="Carry On"
                 placement="bottom" [style.opacity]="hasCarryOn ? 1 : 0.5" style="width: 24px;" alt="">
                        <img src="../../../../../../assets/icons/search-result/aereo/maleta.svg"
                                                tooltip="Maleta"
                 placement="bottom" [style.opacity]="hasCheckedBag ? 1 : 0.5" style="width: 18px" alt="">
                      </div>

                        <p class="date-info-result-flight-weekday">Beneficios</p>

                    </div>


                  </div>


                    <usb-blickoins
                              [categoryId]="categoryId"
                              [blickoins]="blickoins"
                              [stylePathPrice]="stylePathPrice"
                    ></usb-blickoins>

                </div>




              </ng-container>
          </ng-container>

         <ng-container *ngIf="categoryId === 1 || categoryId === 6 || categoryId === 9 || categoryId === 3">
          <img
            [src]="imageUrl"
            style="width: 100%; cursor: pointer; object-fit: cover; object-position: center;"
            [ngStyle]="{
              'height': categoryId === 3 ? '100%' : categoryId !== 1 ? '342.5px' : '352.5px',
              'border-top-left-radius': '7px',
              'border-bottom-left-radius': '7px',
              'filter': 'brightness(0.85)'
            }"
            (click)="openModal()"
            alt="Imagen del producto">

          <div *ngIf="categoryId === 3 && badgeLabel" class="media-badge d-flex align-items-center">
            <img src="../../../../../../assets/icons/search-result/cruise_7788271.svg" width="20px" height="20px" alt="" />
            <span>{{ badgeLabel }}</span>
          </div>

          <img *ngIf="categoryId === 3 && logoUrl" class="media-logo" [src]="logoUrl" alt="Logo del proveedor" />
        </ng-container>

          <ng-container *ngIf="categoryId === 1 || categoryId === 6 || categoryId === 9">

             <ng-container *ngIf="categoryId === 1">
              <div  *ngIf="mealsData !== ''"  class="d-flex" style="height: 35px;position: absolute; top: 26px;left:10px">
                <div class="d-flex align-items-center pl-1 pr-2" style="background-color: white; border-radius: 50rem;gap: .25em; border: 1px solid black">
                    <div class="d-flex align-items-center justify-content-center" style="width: 26px;height: 26px;border-radius: 50%;"
                      [ngStyle]="{'background-color': clientsSettingAppBooking?.clients_setting_global?.color_main_1}">
                    <img style="width: 24px; object-fit: contain;"
                      [src]="mealsData"
                      onerror="if (this.src != 'assets/img/app/rent-a-car-default.png') this.src = 'assets/img/app/rent-a-car-default.png';"
                      alt="Logo del proveedor">
                  </div>
                  <p class="mb-0" style="font-size: 11px;color: black">{{mealsNameRoom}}</p>
                </div>


              </div>
             </ng-container>

              <div *ngIf="logoUrl !== ''" class="d-flex" style="height: 35px;position: absolute; bottom: 15px;left:5px">
                <img style="max-width: 60px; width: 60px; height: 35px; object-fit: contain;"
                    [src]="logoUrl"
                    onerror="if (this.src != 'assets/img/app/rent-a-car-default.png') this.src = 'assets/img/app/rent-a-car-default.png';"
                    alt="Logo del proveedor">
              </div>

              <ng-container *ngIf="categoryId === 1 && exclusiveDeal !== null">
              <div  *ngIf="mealsData !== ''"  class="d-flex" style="height: 35px;position: absolute; bottom: 38px;right:20px">
                <div class="d-flex align-items-center justify-content-center" style="width: 60px;height: 60px;background-color: white; border-radius: 50% 10% 50% 50%; border: 1px solid black">
                    <div class="d-flex align-items-center justify-content-center" style="width: 50px;height: 50px;border-radius: 50%;"
                      [ngStyle]="{'background-color': clientsSettingAppBooking?.clients_setting_global?.color_main_1}">

                          <p *ngIf="exclusiveDeal === 'TOP_HOTEL'" class="mb-0" style="font-family: 'Poppins', sans-serif;font-weight:500;font-size: 9px;color: black; line-height: 1;width: min-content">Top Hotel</p>
                          <p *ngIf="exclusiveDeal === 'EXCLUSIVE_DEAL'" class="mb-0" style="font-family: 'Poppins', sans-serif;font-weight:500;font-size: 9px;color: black; line-height: 1;width: min-content">Oferta Exclusiva</p>

                  </div>

                </div>
              </div>
             </ng-container>

          </ng-container>

          <!-- Logos - Solo para categoryId === 2 (Rent-a-car) -->
          <div *ngIf="categoryId === 2 " class="d-flex flex-column align-items-center mb-4 ml-2">

            <div *ngIf="logoUrl !== ''" class="d-flex mt-3" style="height: 35px;">
              <!-- <img style="max-width: 120px; width: 120px; height: 55px; object-fit: contain;"
                  [src]="logoUrl"
                  onerror="if (this.src != 'assets/img/app/rent-a-car-default.png') this.src = 'assets/img/app/rent-a-car-default.png';"
                  alt="Logo del proveedor"> -->
            </div>

            <div class="d-flex"
                style="height: 35px; border-radius: 2px; border: 1px solid #cfcfcf; width: auto;margin-top:.70em">
              <img style="max-width: 95px; width: 95px; height: 35px; object-fit: contain; padding: 6px;"
                  [src]="supplierLogo"
                  onerror="if (this.src != 'assets/img/app/rent-a-car-default.png') this.src = 'assets/img/app/rent-a-car-default.png';"
                  alt="Logo del suplier">
              <div class="h-auto d-flex justify-content-center align-items-center"
                  style="border-radius: 0 2px 0 0; border-left: 1px solid #cfcfcf; background-color: #defced; width: 35px;">
                <p class="mt-3" style="font-weight: 500; font-family: 'Rubik'; font-size: 12px;">
                  {{ rentalCarData }}
                </p>
              </div>
            </div>

          </div>


